/**
 * Belge gövdesinin tipografisi (docs/DESIGN.md §3 ölçeği): ekranda şablon editörü ve (D7/D8)
 * dönem kopyası aynı görünümü kullanır. ProseMirror çıktısına alt seçicilerle uygulanır; renkler
 * token'dan gelir.
 */
export const DOCUMENT_CLASS = [
  'text-sm leading-relaxed',
  '[&_.ProseMirror]:outline-none',
  '[&_h1]:mt-4 [&_h1]:mb-2 [&_h1]:text-lg [&_h1]:font-semibold [&_h1]:break-after-avoid',
  '[&_h2]:mt-4 [&_h2]:mb-2 [&_h2]:text-sm [&_h2]:font-medium [&_h2]:break-after-avoid',
  '[&_h3]:mt-3 [&_h3]:mb-1 [&_h3]:text-sm [&_h3]:font-medium [&_h3]:break-after-avoid',
  '[&_p]:my-2',
  '[&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5',
  '[&_a]:text-primary [&_a]:underline',
  '[&_table]:my-3 [&_table]:w-full [&_table]:border-collapse',
  '[&_td]:border-border [&_td]:border [&_td]:p-1.5 [&_td]:align-top',
  '[&_th]:border-border [&_th]:bg-surface-subtle [&_th]:border [&_th]:p-1.5 [&_th]:text-left [&_th]:font-medium',
].join(' ')
